import {gql} from "@irati/utils/gql"
import fullUserV4 from "@irati/identity/services/fragments/fullUserV4"
import fullBusiness from "@irati/identity/services/fragments/fullBusiness"

const query = gql`
  query Login($email: String!, $tenantId: String!, $password: String!) {
    login(email: $email, tenantId: $tenantId, password: $password) {
      user {
        ...fullUser
      }
      business {
        ...fullBusiness
      }
      session {
        uuid
      }
      accessToken
    }
  }
  ${fullUserV4}
  ${fullBusiness}
`

export const toString = query.loc.source.body

export default query
